<template>
  <div class="checkbox-container">
    <div class="checkbox-wrapper" :class="{ 'rtl': rightToLeft, 'disabled': disabled, 'inline': inline }">
      <label :for="checkboxId" class="text">{{text}}</label>
      <div class="separator-line" v-if="showSeparator"></div>
      <input type="checkbox" :id="checkboxId" :disabled="disabled" class="checkbox" v-model="currentValue"/>  
      <label :for="checkboxId" class="switch"></label>
    </div>
    <div v-if="description && description.length">
      <button v-if="descriptionClickable" @click="descriptionClick" class="description clickable">{{description}}</button>
      <div v-else @click="descriptionClick" class="description">{{description}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  model: {
    prop: 'value',
    event: 'change'
  },
  data: function () {
    return {
      checkboxId: '',
    }
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    descriptionClickable: {
      type: Boolean,
      default: false
    },
    value: null,
    rightToLeft: {
      type: Boolean,
      default: false
    },
    showSeparator: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    genUniqId() {
      const datestr = new Date().getTime().toString();
      const randomstr = Math.random().toString();
      return datestr + randomstr;
    },
    descriptionClick() {
      this.$emit('descriptionClick');
    }
  },
  computed: {
    currentValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('change', newValue);
      }
    }
  },
  created() {
    this.checkboxId = this.genUniqId();
  }
}
</script>

<style scoped>
.checkbox-container {
  margin-bottom: 1rem;
}
.checkbox-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 5px 10px;
  width: calc(100% - 22px);
  background: var(--input-box-background);
  /* border-radius: 20px; */
  border-radius: var(--ui-control-border-radius);
  border: 1px solid var(--border-color);
}
.checkbox-wrapper.rtl {
  flex-direction: row-reverse;
}
.checkbox-wrapper.inline {
  padding: 0;
  border: none;
  background: none;
  width: 100%;
  max-width: 100%;
  margin-bottom: 5px;
}
.separator-line {
  border-right: 1px solid var(--hr-color);
  width: 1px;
  background: none;
  box-shadow: inset 1px 1px 1px 1px #00000045;
  height: calc(1em + 2px);
  margin-top: 2px;
  margin-left: auto;
  margin-right: 10px;
  display: inline-flex;
}
.checkbox-wrapper.rtl .separator-line {
  margin-left: 10px;
  margin-right: auto;
}
.switch {
  position: relative;
  display: inline-block;
  cursor: pointer;
  width: 3.25em;
  height: calc(1em + 0px);
  /* background: #CDD1DA; */
  background-color: transparent;
  /* border: 1px solid var(--hr-color); */
  border: 1px solid #797979;
  margin-top: 2px;
  border-radius: 1em;
  transition: all 0.2s;
  /* box-shadow: inset 0 2px 3px rgba(0,0,0,.4); */
}

.switch::after {
  content: '';
  position: absolute;
  width: calc(1em + 4px);
  height: calc(1em + 4px);
  border-radius: 1em;
  background-color: white;
  top: -2px;
  left: 0;
  transition: all 0.2s;
  box-shadow: 0 2px 5px rgba(0,0,0,.4);
}

.checkbox:checked + .switch::after {
  left: calc(100% - 1em - 2px);
}
.checkbox:checked + .switch {
  background-color: #006cfa;
  border-color: transparent;
}
.checkbox {
  display : none;
}
.description {
  margin: 0;
  margin-top: 0.25rem;
  /* font-size: 0.8rem; */
  font-size: small;
  padding: 0px 5px;
  width: calc(100% - 22px);
  color: var(--item-state-description-color);
}
.description.clickable {
  border: none;
  cursor: pointer;
  background: none;
  outline: none !important;
  text-align: start;
}
.text {
  display: inline;
  margin-right: 10px;
  width: 100%;
  margin-top: 0;
  align-content: center;
}
.checkbox-wrapper.rtl .text {
  margin-left: 10px;
  margin-top: -2px;
}
.checkbox-wrapper.disabled .text {
  color: var(--textColorDisabled);
}
@media (hover: hover) {
  .description.clickable:hover {
    color: var(--textColor);
  }
}

</style>
